import { render, staticRenderFns } from "./Saldos.vue?vue&type=template&id=6c6220c4&"
import script from "./Saldos.vue?vue&type=script&lang=js&"
export * from "./Saldos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports